import { render } from "./NavMenu.vue?vue&type=template&id=65930761"
import script from "./NavMenu.vue?vue&type=script&lang=js"
export * from "./NavMenu.vue?vue&type=script&lang=js"

import "./NavMenu.vue?vue&type=style&index=0&id=65930761&lang=css"
script.render = render

export default script